export const PERSON_STATUS_META = {
  on_job: { label: "On a Job", cls: "border-blue-200 text-blue-600 dark:border-blue-500/30 dark:text-blue-400" },
  time_off: { label: "Time Off", cls: "border-amber-200 text-amber-600 dark:border-amber-500/30 dark:text-amber-400" },
  available: { label: "Available", cls: "border-emerald-200 text-emerald-600 dark:border-emerald-500/30 dark:text-emerald-400" },
  off_hours: { label: "Outside Hours", cls: "border-slate-200 text-slate-500 dark:border-white/15 dark:text-slate-400" },
  inactive: { label: "Deactivated", cls: "border-red-200 text-red-600 dark:border-red-500/30 dark:text-red-400" },
};
